<template>
  <div class="classmatter">
    <navbar :title="text_title"></navbar>
    <div class="topbanner">
        <img src="../../assets/kcjj.jpg" width="100%" alt="">
    </div>
    <div class="classtitle">
        <div class="classname">{{makeCourse_list.name}}</div>
        <div class="classtime">{{makeCourse_list.classtime_begin,makeCourse_list.classtime_end}}</div>
    </div>
    <!-- 课程列表 -->
    <div class="courseplan" v-show="{planshow: planste = true}">
        <div class="plantitle kechengjihua">
            <i></i>
            课程计划
        </div>  
        <!-- 系列课程列表 -->
        
        <div class="courselist" 
            v-for="(courselistb) in course_listb"
            v-bind:key="courselistb.cid" 
            @click="listclick(courselistb)">
            <div>
                <i class="videolistico"></i>
                {{ courselistb.name }}
            </div>
            <div class="clear">
                 <van-col offset="0" span="14">
                     <div v-if="courselistb.live_status =='1'" style="color:#999999">未开始</div>
                    <div v-if="courselistb.live_status =='2'" style="color:red;">直播中</div>
                    <div v-if="courselistb.live_status =='3'" style="color:#999999">已结束</div>
                 </van-col>
                <van-col offset="" span="10">{{courselistb.classtime_begin,courselistb.classtime_end}}</van-col>
            </div>
        </div>

        <van-loading class="login_btn2 loadingshow" v-if="load" type="spinner">加载中...</van-loading>

    </div>

    <div class="courseplan">
        <div class="plantitle jiaoshi">
            <i></i> 
            授课老师
        </div>  
        <div class="teacherinfo clear">
            <div>
                <img src="https://rjwpublic.oss-cn-qingdao.aliyuncs.com/user/avatar/1059021557902326240avatar.jpg" width="100%" alt="">
            </div>
            <div>
                <div>主讲：{{makeCourse_list.speak_teacher}}</div>
                <div>
                    大语文教育探索者，
                    集作家、编辑、相声、话剧、阅卷人于一身
                    以生动的课堂表演、趣味教学著称
                    擅长方法总结和传授，让孩子即学即用
                    教学经验5年+，授课学员超过数千人
                    课堂好评率99%以上
                </div>
            </div>
        </div>
    </div>
    <div class="courseplan" v-if="photoval">
        <div class="plantitle">
            <i></i>
            课程详情
        </div> 
        <img :src="makeCourse_list.profile_photo" width="100%" alt="">
    </div>

    <div class="bottombuy clear">
        <div>
            <div>
                <span>￥{{makeCourse_list.sale_price}}</span>
                <span>￥{{makeCourse_list.price}}</span>
            </div> 
            <div>{{makeCourse_list.buy_num}}人报名</div>
        </div>
        <div>
            <!-- <van-button type="danger">立即报名</van-button> -->
            <!-- <van-button type="primary" @click="study()">立即学习</van-button> -->

            <!-- 1：系列  2：单独课程--> 
            <div class="btns" v-if="course_type == 2">
              <!-- 判断是付费课程还是直播课程 1付费 2密码-->
              <div v-show="this.live_type == 1">
                  <!-- 判断是否付款 0：未付款 1：付款 -->
                <van-button type="primary"  
                    @click="handleOrderClass(course_id)"
                    v-show="makeCourse_list.buy_status == 0"
                >立即报名</van-button>

                  <van-button type="primary" 
                    v-show="makeCourse_list.buy_status == 1"
                    @click="handleStartClass()"
                  > 立即学习
                  </van-button>    
              </div>
              <van-button type="primary" 
                @click="pawpupshow()"
                v-show="this.live_type == 2"
                class="order_class_btn_blue horizontal_center margT_10"
              >立即学习</van-button> 
            </div>

            <!-- 系列课程按钮 -->
            <div v-if="course_type == 1">
                <van-button type="primary"  
                   @click="handleOrderClass(course_id)"
                    v-show="makeCourse_list.buy_status == 0"
                >立即报名</van-button>
                <van-button type="primary" disabled v-show="makeCourse_list.buy_status == 1">已报名</van-button>
                
            </div>
        </div>
    </div>

        <!-- 观看直播密码弹窗 -->

    <div class="playpopbox" v-bind:class="{ pawpopboxshow: btnavtive == true }">
      <div class="playpopup">
        <input class="pwdinp" type="password" placeholder="请输入直播密码" v-model="livepwd">
        <div class="playbtn playbtnb clear">
          <div @click="livepwdbtn()">确定</div>
          <div @click.stop="offpopbtn()">取消</div>
        </div>
      </div>
    </div>



  </div>
</template>

<script>
import navbar from '../../components/Navbar'
import '@/assets/classmatter.css'
import http from '@/plugins/http.js'
//折叠面板
import Vue from 'vue';
import { Collapse, CollapseItem } from 'vant';
Vue.use(Collapse);
Vue.use(CollapseItem);
//栅格
import { Col, Row } from 'vant';
Vue.use(Col);
Vue.use(Row);
Vue.use(http)
//按钮
import { Button } from 'vant';
Vue.use(Button);
import { Toast } from 'vant';
Vue.use(Toast);
import { Loading } from 'vant';
Vue.use(Loading);
export default {
    components:{
        navbar
    },
    data() {
        return {
            text_title:'课程详情',
            activeNames: ['0'],
            course_listb:[],
            makeCourse_list:{
                subject_name:'',
                name:'',
                experience_url:'',
                profile_photo:'',
                classtime_begin:'',
                classtime_end:'',
                course_type:'',
            },
            planste: false,
            userinfo:'',
            course_id:'',
            photoval:'',
            course_type:'',
            live_type:'',
            userInfo:'',
            btnavtive: false,
            livepwd:'',
            load:false,
        }   
    }, 
    computed:{

    },
    created(){
        // console.log(this.$route.parse)
    },
    mounted(){
        if (localStorage.getItem("userInfo")) {
            this.userInfo = JSON.parse(localStorage.getItem("userInfo"))
        }
        this.getuserinfo();
        this.getMakeCourseList();//获取详情
        this.courselist()//系列课程列表

    },
    methods:{
        icon () {
            this.$router.go(-1)
        },
        pawpupshow(){
            this.btnavtive = true
        },
        offpopbtn(){//关闭图片
            this.btnavtive = false//密码弹窗
        },

        listclick(courselistb){
            console.log(courselistb)
                //报名状态 0 为立即报名 1 为报名完学习  
            this.buystatus = this.makeCourse_list.buy_status;
            this.lxcid = courselistb.cid;       
            console.log(this.lxcid,"系列cid")
            this.Type = courselistb.type;
            // 直播类型  是密码直播还是付费直播 livetype 为1 付费直播 2密码直播
            if( courselistb.livetype == 1 ){
                // 判断类型是已付款还是未付款 buystatus  0：未付款  1：已付款
                if( this.buystatus == 0 ){
                this.handleOrderClass(courselistb);
                }else{  
                    if( courselistb.live_status == 1 ){//未直播
                    alert("直播还未开始");
                    }
                    if( courselistb.live_status == 2 ){//直播中
                    this.handleStartSeries(courselistb)
                    }
                    if( courselistb.live_status == 3 ){//已结束
                    this.handleStartSeries(courselistb)
                    } 
                }
            }else if(  courselistb.livetype == 2  ){
            this.pawpupshow();
            }     
        },

        livepwdbtn(){//密码确定
            // /live/course/checkClassPwd 
            var inppwd = this.livepwd;
            // 判断课程  1：系列   2：单独课程
            if( this.course_type == 1 ){
                this.cida = this.Cid
                console.log(this.cida,"系列")
            }else if( this.course_type == 2 ){
                this.cida = this.course_id
                console.log(this.course_id)
                console.log(this.cida,"课程")
            }

            if( !inppwd){
                    Toast("密码不能为空");
                return ;
            }
            this.$http.post('/live/course/checkClassPwd',
                {
                token: this.userInfo.token,
                cid: this.cida,
                classpwd: inppwd,
                }
            )
            .then(pwdreturn => {
                console.log(pwdreturn)
                this.livesta = pwdreturn.data.state
                if( this.livesta == 0 ){
                this.handleStartClass()
                }else{
                    Toast(pwdreturn.data.msg);
                }
            })
            },


        getuserinfo(){//获取需要的信息
            this.course_id = this.$route.query.cid;
            // this.course_id =  '809965'
            // this.course_type = '1'
            this.course_type = this.$route.query.type;
            // this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
            console.log(this.userInfo);
        },

        async getMakeCourseList () {//获取课程信息
            
            var params = {}
            if (this.course_id) {
                params.cid= this.course_id;
            }
            var href = window.location.href
                if (href.indexOf('course_id') > 0) {
                var course_id = href.substring((href.indexOf('course_id=') + 3),href.length);
            }
            if (!this.course_id) {
                params.cid=this.course_id;
            }
            if(this.userInfo && this.userInfo.token) {
                params.token = this.userInfo.token;
            }
            // console.log(params)
            const makeCourseRes=await this.$http.post ('/live/course/index',params)
            // console.log(makeCourseRes)
            if (makeCourseRes.data.state===0) {
            // debugger
            this.makeCourse_list = makeCourseRes.data.result
                console.log(this.makeCourse_list)
            }else if (makeCourseRes.data.msg===1){
                Toast(makeCourseRes.data.msg);
            }
            if( this.makeCourse_list.profile_photo == "" ){
                this.photoval = false
            }else{
                this.photoval = true
            }
        },
        
        courselist(){//获取系列课程列表 
            this.load = true;
            // this.course_id = JSON.parse(this.$route.query.course_id);
            // this.course_type = this.$route.query.course_type;
            // this.course_type = '2'// 课程类型  1：系列  2：单独课程
            this.live_type = this.$route.query.livetype;//直播类型
            // console.log(this.live_type,"直播类型")
            if( this.course_type == 1 ){
                this.planste = true
                this.$http.post('/live/index/series_courseinfo',
                    {
                        c_id: this.course_id
                    },{
                        emulateJSON:true
                    }
                )
                .then(listb => {
                    if(listb.data.state == 0){
                        this.load = false;
                        this.course_listb = listb.data.result; 
                        console.log(this.course_listb)
                    }else if(listb.data.state ==  1){
                        Toast(listb.data.result.name);
                    }
                })
                .catch(error => {
                    console.log(error.response)
                }) 
            }else{
                this.planste = false
            }
        },

        // study(){
        //     this.$router.push({
        //         name:'playback',
        //         query:{
        //             xlcid: this.course_id,
        //             kccid: '444894',
        //             coursetype: this.course_type
        //         }
        //     })
        // },
        async handleOrderClass(course_id) {
            console.log('获取下单号码前的')
            // console.log(course)
            console.log(this.course_id)

            //未登录 是否登录
            if (this.userInfo === null || this.userInfo.token === null) {
                this.$router.push({path:'/login'})
            return
            }
            const orderCard = await this.$http.post('/live/payment/add_refill',
            {cid:this.course_id,token:this.userInfo.token},
            {
                headers: { 'content-type': 'application/x-www-form-urlencoded' }
            }
            )
            if (orderCard.data.state ===0) {
            this.orderCardNum = orderCard.data.result
            console.log('获取下单的号码')
            console.log(this.orderCardNum)

            //如果课程价格是0，不需要生成订单，直接立即学习即可
            if (this.makeCourse_list
                && this.makeCourse_list.sale_price
                && this.makeCourse_list.sale_price === "0.00") {
                this.makeCourse_list.buy_status = 1
                return
            }

            this.toOrder(this.orderCardNum)
            }else if (orderCard.data.state ===1) {
                this.$router.push({path:'/login'})
            }
        },
        handleStartClass: function () {
            let userInfo = JSON.parse(localStorage.getItem("userInfo"))
            console.log("立即学习")
            this.token = this.userInfo.token
            this.Cid = this.makeCourse_list.cid
            console.log(this.Cid);
            //未登录 是否登录
            if (this.userInfo === null || this.userInfo.token === null) {
                this.$router.push({path:'/login'})
            return
            }
            if (this.makeCourse_list.live_status === '3') {
            //回放
            this.$router.push({
                name:'playback',
                query:{
                    //liveDetail:JSON.stringify(this.makeCourse_list)
                    coursetype: this.course_type,
                    cida: this.cida,//系列
                    Cid: this.Cid,
                    //Type:this.Type,
                    Token:this.token
                }
            })
            
            console.log("进入判断")
            } 
            else if (this.makeCourse_list.live_status === '2') {
            //直播
            this.$router.push({
                name:'whiteBoard',
                query:{
                userInfo: userInfo,
                liveDetail:{
                    room_id: this.makeCourse_list.cid,
                    speaker_teacher_id: this.makeCourse_list.speaker_teacher_id,
                }
                }
            })
            }if (this.makeCourse_list.live_status === '1') {
                Toast('直播未开始');
            }
        },
        //如若报名成功，立即学习事件
        handleStartSeries:function(courselistb) {//xiliekechengfangfa
            let userInfo = JSON.parse(localStorage.getItem("userInfo"))
            console.log("立即学习")
            this.token = this.userInfo.token
            this.Cid = courselistb.cid
            this.live_status = courselistb.live_status
            console.log(this.Cid);
            console.log(this.live_status);
            if (this.live_status === '3') { 
            //回放
            this.$router.push({
                name:'playback',
                query:{
                //liveDetail:JSON.stringify(this.makeCourse_list)
                xlcid: this.Cid,//系列
                Cid: this.Cid,
                // Cid: this.cida,
                //Type:this.Type,
                Token:this.token,
                coursetype: this.course_type,
                }
            })
            
            console.log("进入判断")
            } 
            else if (this.live_status === '2') {
            //直播  
            this.$router.push({
                name:'whiteBoard',
                query:{
                userInfo:userInfo,
                liveDetail:{
                    room_id: courselistb.cid,
                    speaker_teacher_id: courselistb.speaker_teacher_id,
                }
                }
            })
            }if (this.live_status === '1') {
                Toast('直播未开始');
                console.log("xiliekechengfangfa")
            }
        },
    },
}

</script>


// WEBPACK FOOTER //
// src/pages/classdetails/classdetails.vue